import { useContext} from "react";
import { ThemeContext } from "../../context/ThemeContext";

function Card(props){
    const theme = useContext(ThemeContext);
    const {dark} = theme;
    return <div className={`relative  p-2 ${dark ? "bg-neutral-900" : "bg-white"} rounded-lg w-full h-full  justify-center lg:justify-start items-center shadow-md`}>{props.children}</div>
}

export default Card;